import React, { useEffect, useState } from "react";
import MockedBadge from "@/components/MockedBadge";
import api from "@/lib/api";

/**
 * Reads /api/integrations/email-mode to decide whether to render the MOCKED badge.
 * Hides itself when service goes live. Re-checks every 60s so a mid-run env flip
 * is reflected without a full page reload.
 */
export default function LiveModeBadge({ service = "resend", className = "" }) {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/integrations/email-mode");
        const m = service === "twilio" ? data.twilio_mode : data.mode;
        if (alive) setMode(m);
      } catch { /* not authed */ }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, [service]);

  if (mode !== "mock") return null;
  return <MockedBadge service={service} className={className} />;
}
